import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'

import Loader from './Loader'
import { getVenues } from '../store/Venues/selector'
import { fetchVenues } from '../store/Venues/actions'
import NotAuthorizedPage from '../pages/NotAuthorized'

import { isAuth, redirectToLogin } from '../utils/auth'

const AuthorizedRoute = ({ fetchVenues, isVenuesEmpty, component: Component, ...rest }) => {
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    fetchVenues().then(() => setLoading(false))
  }, [fetchVenues])


  const renderPage = (isVenuesEmpty, props) => {
    if (isLoading) return <Loader />

    if (isVenuesEmpty) {
      return <NotAuthorizedPage />
    } else {
      return <Component {...props} />
    }
  }

  return (
    <Route {...rest} render={props => {
      return (
        isAuth() ? renderPage(isVenuesEmpty, props) : redirectToLogin()
      )
    }} />
  )
}

AuthorizedRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
}

const mapStateToProps = state => ({
  isVenuesEmpty: isEmpty(getVenues(state)),
})

const mapDispatchToProps = dispatch => ({
  fetchVenues: () => dispatch(fetchVenues()),
})

export default connect(mapStateToProps, mapDispatchToProps)(AuthorizedRoute)

